import { GetPromotionPendingMessageContext } from "./promotionMessageHelper";

/**
 * Gets the first cart item with manual promotion albums pending to be added.
 *
 * @param {Object} state Vuex state.
 * @returns {Object|null} Pending promotion cart item, or null when the cart is complete.
 */
export function GetIncompletePromotionItem(state = {}) {
    return Object.values(state.shoppingCart || {}).find(
        (item) => item?.IsPromotionManualPending
    ) || null;
}

/**
 * Applies the payment route guard for manual album promotions.
 * If the customer still has free albums to select, payment is blocked and the
 * user is sent back to the albums page so the cart does not close with an
 * incomplete commercial block.
 *
 * @param {Object} params Guard parameters.
 * @param {Object} params.to Target route.
 * @param {Object} params.store Vuex store instance.
 * @param {Object} params.i18n Vue i18n instance.
 * @param {Object} params.toast Vue toast service.
 * @returns {Object|null} Redirect route, or null when navigation can continue.
 */
export function GetIncompletePromotionPaymentRedirect({ to, store, i18n, toast }) {
    if (to.name !== "payment") {
        return null;
    }

    const incompletePromotionItem = GetIncompletePromotionItem(store.state);

    if (!incompletePromotionItem) {
        return null;
    }

    const messageContext = GetPromotionPendingMessageContext(incompletePromotionItem);

    toast.open({
        message: i18n.tc(
            messageContext.key,
            messageContext.choice,
            messageContext.params
        ),
        type: "info",
    });

    return { name: "albumes" };
}

export default {
    GetIncompletePromotionItem,
    GetIncompletePromotionPaymentRedirect,
};
